export default __webpack_public_path__ + "static/media/07.13c51879.jpg";